"use client";

import { ICONS_VARIABLE_NAMES } from "@/common/globalTypes/enums/common";

const Like = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d={`M9.18797 2.00081V1.87398C9.3732 1.97921 9.54514 2.11675 9.67599 2.29426C9.85612 2.53865 10.0096 2.9267 9.92525
         3.58004L9.46647 5.37456C9.27024 6.14084 9.82533 6.94917 10.6704 6.94917L13.5118 6.94917C13.9557 6.94917 14.3419 7.38767 
         14.2313 7.90677L13.0209 13.5888C12.9363 13.9885 12.6003 14.25 12.2421 14.25H8.10504C7.81103 14.25 7.51793 14.1972 7.23734
          14.0928C6.85319 13.9491 6.27451 13.7343 5.52063 13.4562L5.52063 7.73536L8.40101 4.21805C8.64965 3.91546 8.8421 3.57429 
          8.97444 3.21151C9.11522 2.8256 9.18797 2.41522 9.18797 2.00081ZM7.68797 1.55412C7.68797 0.677963 8.55756 -0.00193305 
          9.43291 0.335826C9.88025 0.508325 10.457 0.825716 10.8834 1.40425C11.3249 2.00324 11.5497 2.80649 11.4053 3.82867L11.3995 
          3.86954L10.9956 5.44917L13.5118 5.44917C14.9675 5.44917 15.9956 6.82402 15.6984 8.2193L14.4881 13.9009C14.2629 14.9633 13.3393 
          15.75 12.2421 15.75H8.10504C7.63028 15.75 7.15877 15.6643 6.71185 15.4977C6.40823 15.3842 5.98089 15.2254 5.43932 15.0252C5.28007 
          15.438 4.88573 15.7447 4.39893 15.7447H1.36648C0.728956 15.7447 0.25 15.2187 0.25 14.6171L0.25 5.98114C0.25 5.37962 0.728955 
          4.85358 1.36648 4.85358L4.39893 4.85358C4.85787 4.85358 5.23463 5.12618 5.4097 5.50331L7.24089 3.26719L7.24181 3.26607C7.52838 
          2.9175 7.68797 2.46751 7.68797 2.00081V1.55412ZM1.75 14.2447L1.75 6.35358L4.01541 6.35358L4.01541 14.2447H1.75Z`}
        fill={ICONS_VARIABLE_NAMES.primary}
      />
    </svg>
  );
};

export default Like;
